/* eslint-disable react/no-unescaped-entities */
import React, { useContext } from 'react';
import { Box, Typography } from '@material-ui/core';
import { makeStyles, Theme } from '@material-ui/core/styles';
import { MdVideoLibrary } from 'react-icons/md';
import colorContext from '../../../../Context/colorContext';

export default function Title(): JSX.Element {
  const { colors } = useContext(colorContext);
  const useStyles = makeStyles((theme: Theme) => ({
    main: {
      width: '100%',
      height: 200,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: colors.accentColorBackground,
      [theme.breakpoints.down('sm')]: {
        padding: '0px 16px',
      },
    },
    content: {
      display: 'flex',
      maxWidth: '1040px',
      alignItems: 'center',
      width: '100%',
      justifyContent: 'space-between',
      [theme.breakpoints.down('sm')]: {
        flexDirection: 'column-reverse',
        justifyContent: 'center',
      },
    },
    title: {
      fontSize: theme.typography.pxToRem(32),
      fontWeight: 800,
      color: colors.textAccentColor,
      marginBottom: 16,
      [theme.breakpoints.down('sm')]: {
        fontSize: theme.typography.pxToRem(24),
        textAlign: 'center',
      },
    },
    subTitle: {
      fontSize: theme.typography.pxToRem(18),
      fontWeight: 400,
      color: colors.textAccentColor,
      [theme.breakpoints.down('sm')]: {
        fontSize: theme.typography.pxToRem(16),
        textAlign: 'center',
      },
    },
    icon: {
      width: 80,
      height: 80,
      color: colors.textAccentColor,
      [theme.breakpoints.down('sm')]: {
        width: 40,
        height: 40,
      },
    },
  }));
  const classes = useStyles();
  return (
    <Box className={classes.main}>
      <Box className={classes.content}>
        <Box>
          <Typography className={classes.title} variant='h4'>
            Vídeos
          </Typography>
          <Typography className={classes.subTitle}>
            Fique sempre atualizado com nossos vídeos.
          </Typography>
        </Box>
        <MdVideoLibrary className={classes.icon} />
      </Box>
    </Box>
  );
}
